import axios from 'axios';
import * as bootstrap from '../vendor/bootstrap';
import {ebus} from '@/vendor/ebus';
import {generateClientId} from "@/vendor/util";

export const baseURL = '../';
// export const baseURL = 'https://api-onlytonapoli.qsignal.eu/';
// export const baseURL = 'https://api-speedydemo.qsignal.eu/';
// export const baseURL = 'https://api-testmergeport.qsignal.eu/';
// export const baseURL = 'https://api-besttaste.qsignal.eu/';
// export const baseURL = 'https://api-testtaste.qsignal.eu/';
// export const baseURL = 'https://api-testself.qsignal.eu/';

const ACTION_GET_BASE_CONTEXT = 'GetBaseContext';
// const LOAD_VISITOR_CONFIG = 'LOAD_VISITOR_CONFIG';

let counter4xx = 0;

let secToken = 'deactivated';

export function setSecToken(v) {
  secToken = v;
}

function handle404(errResponse) {
  if (!errResponse) {
    return false;
  }

  // console.log('??? handle 404 errResponse: ',errResponse);

  if (
    errResponse.status === 404 ||
    errResponse.status === 401 ||
    errResponse.status === 402
  ) {
    counter4xx++;
    console.log('counter4xx: ' + counter4xx);
    if (counter4xx > 0) {
      // goExitApp = true;
      // window.location.replace('https://pages-eu1.qsignal.eu:1443/exit/nine.html');
      return true;
    }
  }
  return false;
}

// export function loadConfig(configName, restaurantId, callback, error) {
//     console.log('load config ' + configName + ' from the middleware');
//     let loadMessage = {action: LOAD_VISITOR_CONFIG, configName: configName, restaurantId: restaurantId};
//     xhrSend(true, loadMessage, (reply) => {
//         if (!reply || JSON.stringify(reply).length < 2) {
//             callback(null);
//         } else {
//             callback(reply);
//         }
//     }, error);
// }

export function xhrGetFileContent(path, callback, error) {
  // let accept = {'Accept': 'text/javascript'};
  axios.get(path, {
    //config
  })
    .then((reply) => {
      // console.log('<<< Reply ', reply);
      // console.log('<<< Reply :' + JSON.stringify(reply));
      if (reply && reply.data) {
        if (reply.data.secTokenError) {
          ebus.$emit('secTokenError');
        }
        if (reply.data.jwtInvalid) {
          ebus.$emit('jwtInvalid');
        }
        callback(reply.data);
      } else {
        console.log('response not ok for ' + path);
        error();
      }
    })
    .catch((err) => {
      // error callback
      console.log('Catched: No response for get request to ' +
        path + ' received; Error: ', err);
      if (error) {
        error(err);
      }
    });
}

export function xhrGetImage(path, base64response, error) {
  let id = bootstrap.getBtaste();
  if (!id) {
    id = generateClientId();
  }
  axios.get(path, {
    headers: {
      btaste: id
    },
    timeout: 3000,
    responseType: 'arraybuffer'
  })
    .then(reply => {
      // console.log('<<< Reply image :',reply);
      const buffer = Buffer.from(reply.data, 'base64');
      // console.log('image buffer: '+buffer);
      base64response(buffer);
    }).catch(err => {
    // error callback
    console.log('Catched: No response for get request to ' + path + ' received; Error: ', err);
    if (error) {
      error(err)
    }
  });
}

export function xhrGet(path, headerMap, callback, error, timeoutOverride) {
  let timeout = 12000;
  if (timeoutOverride || !navigator.onLine) {
    timeout = timeoutOverride;
  }

  let headersMerged;
  let accept = {'Accept': 'application/json'};
  if (!headerMap.accept) {
    headersMerged = {...accept, ...headerMap};
  } else {
    headersMerged = headerMap;
  }

  axios
    .get(baseURL + path, {
      headers: headersMerged,
      timeout: timeout,
    })
    .then((reply) => {
      // console.log('<<< Reply ', reply);
      // console.log('<<< Reply :' + JSON.stringify(reply));
      if (reply && reply.data) {
        callback(reply.data);
      } else {
        console.log('response not ok');
        error();
      }
    }).catch((err) => {
    // error callback
    console.log('Catched: No response for get request to ' + path + ' received; Error: ', err);
    if (error) {
      error(err);
    }
  });
}

export async function xhrSend(expectReply, message, callback, error, timeoutOverride) {
  if (!message) {
    return;
  }

  // if (message.simulateTransportError) {
  //     error(new Error('simulateTransportError'));
  //     return;
  // }

  if (bootstrap.getBtaste().length < 25) {
    console.log('debugtaste: btaste too short: ' + bootstrap.getBtaste());
    //retry
    setTimeout(() => {
      xhrSend(expectReply, message, callback, error, timeoutOverride);
    }, 100);
    return;
  }

  message.channel = 'on-the-go';
  // message.appId = bootstrap.appId;
  // if (!('uid' in message)) {
  message.btaste = bootstrap.getBtaste();


  if (secToken) {
    message.secToken = secToken;
  }
  // }
  // tc.tmpKey = tagData.tmpKey;
  // message.clientTime = new Date().toISOString();


  console.log('>>>>>>>>>> ', message);

  let timeout = 10000;
  if (timeoutOverride) {
    timeout = timeoutOverride;
  }
  message.timeout = timeout;

  try {
    if (expectReply) {
      try {
        axios
          .post(baseURL + 'inbound/v/service', message, {
            headers: {'Content-Type': 'application/json'}, timeout: timeout
          })
          .then((reply) => {
            // console.log('<<< Reply ', reply);
            // console.log('<<< Reply :' + JSON.stringify(reply));
            if (reply && reply.data) {
              if (reply.data.secTokenError) {
                ebus.$emit('secTokenError');
              }
              if (reply.data.jwtInvalid) {
                ebus.$emit('jwtInvalid');
              }
              callback(reply.data);
            } else {
              console.log('response not ok');
              error();
            }
          }).catch((err) => {
          if (!handle404(err)) {
            // error callback
            console.log('Catched error: ', err);
            try{
              if (err.includes("timeout of 10000ms exceeded")
                || err.includes("timeout of 300000ms exceeded")) {
                console.log('xhr connection lost. going to lazyHandleFallbackUrl...');
                // try {
                //   lazyHandleFallbackUrl();
                // } catch (err) {
                //   try {
                //     console.log('xhr  connection lost. going to  window.lazyHandleFallbackUrl()...');
                //     window.lazyHandleFallbackUrl();
                //   } catch (err2) {
                //   }
                // }
              }
            }catch (e){

            }
            if (error) {
              error(err);
            }
          }
        });
      } catch (sendError) {
        console.log('sendException: ' + sendError);
        error(sendError);
      }
    } else {
      console.log('!!!! expect no reply');
      try {
        axios
          .post(baseURL + 'inbound/v/service', message, {
            headers: {'Content-Type': 'application/json'}, timeout: timeout
          })
          .then((reply) => {
            if (callback) {
              callback();
            }
          }).catch((err) => {
          if (!handle404(err)) {
            // error callback
            console.log('Catched: Action error: ', err);
            if (error) {
              error(err);
            }
          }
        });
      } catch (err) {
        console.log('error: Action failed', err);
        if (error) {
          error(err);
        }
      }
    }
  } catch (outerErr) {
    console.log('Unexpected error', outerErr);
    if (error) {
      error(outerErr);
    }
  }
}

export function getBaseContext(installed, callback, error) {
  console.log('getBaseContext from the middleware');

  let action = {action: ACTION_GET_BASE_CONTEXT};
  action.installed = installed;
  action.userAgentData = window.navigator.userAgentData;
  console.log('isInstalled=' + installed);
  xhrSend(true, action, (reply) => {

    console.log('BaseContext reply XXXXXXXXXXXXXXXXX ', reply);

    if (!reply || !reply.ok) {
      console.log('BaseContext response incomplete');
      error();
      return;
    }
    // restaurantData.restaurantId = parseInt(reply.restaurantId, 10);
    // restaurantData.restaurantName = reply.restaurantName;
    // restaurantData.username = reply.username;
    // restaurantData.role = reply.role;
    // restaurantData.customerId = reply.customerId;
    callback(reply);
  }, (err) => {
    error(err);
  });
}
